import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { IframeUtils, MessageUtils } from 'feature-unboxing-common';
import { jsx as _jsx } from "react/jsx-runtime";
export function WizardMobileFooter({
  onClickCancel
}) {
  const onCancel = IframeUtils.isInIframe() ? () => MessageUtils.sendCloseIframeMessage() : onClickCancel;
  return /*#__PURE__*/_jsx(View, {
    position: "fixed",
    blockSize: "100px",
    inlineSize: "100%",
    insetInlineStart: "0",
    insetBlockEnd: "0",
    backgroundColor: "fill-surface-raised",
    paddingBlock: "100",
    children: /*#__PURE__*/_jsx(Flex, {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      paddingBlockStart: "300",
      children: /*#__PURE__*/_jsx(Button, {
        use: "link",
        marginInlineStart: "300",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(Text, {
          textDecoration: "underline",
          typography: "body-125",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "app.wizard.footer.cancel"
          })
        })
      })
    })
  });
}